export default "__VITE_ASSET__DTZu9MTf__"